import { useEffect } from "react";
import { UseKeyboardNavigation } from "./types";

export const useKeyboardNavigation: UseKeyboardNavigation = ({
  frameCount,
  currentFrameIndex,
  changeSelectedFrameIndex,
  isDisabled,
}) => {
  useEffect(() => {
    const handleKeyDown = (event: KeyboardEvent) => {
      if (isDisabled || (frameCount === 0 && event.key !== "Escape")) {
        return;
      }

      switch (event.key) {
        case "ArrowLeft":
        case "ArrowUp": {
          event.preventDefault();
          changeSelectedFrameIndex({
            newIndex: Math.max(0, currentFrameIndex - 1),
            method: "keyboard-left",
          });
          break;
        }
        case "ArrowRight":
        case "ArrowDown": {
          event.preventDefault();
          changeSelectedFrameIndex({
            newIndex: Math.min(frameCount - 1, currentFrameIndex + 1),
            method: "keyboard-right",
          });
          break;
        }
        case "Home": {
          event.preventDefault();
          changeSelectedFrameIndex({
            newIndex: 0,
            method: "keyboard-home",
          });
          break;
        }
        case "End": {
          event.preventDefault();
          changeSelectedFrameIndex({
            newIndex: frameCount - 1,
            method: "keyboard-end",
          });
          break;
        }
        default: {
          break;
        }
      }
    };

    window.addEventListener("keydown", handleKeyDown);
    return () => {
      window.removeEventListener("keydown", handleKeyDown);
    };
  }, [isDisabled, frameCount, currentFrameIndex, changeSelectedFrameIndex]);
};
